import ReducerCreator from '../registerReducer';
import { buildStoreItem } from '../storeItemBuilder';
import * as OBJECTACCESSRIGHTS from './objectAccessRights.constants';
import { ObjectAccessRights } from '../../models';
import { StoreItem, copy } from '../Store';

const r = new ReducerCreator<ObjectAccessRights>()
    .register<ObjectAccessRights[]>(OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_LOAD, () => {
        const newItem = new StoreItem<ObjectAccessRights>();
        newItem.isLoading = true;
        return newItem;
    })
    .register<ObjectAccessRights[]>(OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_LOAD_SUCCESS, (item, payload) => {
        return buildStoreItem(payload);
    })
    .register<ObjectAccessRights>(OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_UPDATE, (item, payload) => {
        const newItem = copy(item);
        newItem.isLoading = true;
        return newItem;
    })
    .register<ObjectAccessRights[]>(OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_UPDATE_SUCCESS, (item, payload) => {
        const newItem = copy(item);
        const { dictionary } = newItem;
        payload.forEach(p => {
            dictionary[p.guid] = p;
        });
        newItem.isLoaded = true;
        newItem.isLoading = false;
        return newItem;
    });

export function objectAccessRightsReducer(state: StoreItem<ObjectAccessRights> = new StoreItem<ObjectAccessRights>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
